import { render, staticRenderFns } from "./ReferralsBanner.vue?vue&type=template&id=9e5cf806&"
import script from "./ReferralsBanner.vue?vue&type=script&lang=js&"
export * from "./ReferralsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports